import React from 'react';

import FinancialDetails from './FinancialDetail';
import ProductList from './ProductList';
import Translations from '../../../assets/locale/en/content.json';
import { TngGrid } from '../../../components/common';
import { CustomTabs } from '../../../components/CustomTab/CustomTabs';

interface TabConfig {
  label: string;
  id: number;
}

const tabConfig: TabConfig[] = [
  { label: Translations.OrderSummary.productList, id: 1 },
  { label: Translations.OrderSummary.financialDetails, id: 2 },
];

const GridTabs = () => {
  return (
    <TngGrid container className="order_summary_grid_container">
      <CustomTabs tabs={tabConfig}>
        <ProductList />
        <FinancialDetails />
      </CustomTabs>
    </TngGrid>
  );
};

export default GridTabs;
